'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _react = require('react');var _react2 = _interopRequireDefault(_react);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var NotFound = function NotFound() {return (
        _react2.default.createElement('div', null, 'PAGE NOT FOUND - 404'));};exports.default =



NotFound;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9sYXlvdXQvTm90Rm91bmQvaW5kZXguanMiXSwibmFtZXMiOlsiTm90Rm91bmQiXSwibWFwcGluZ3MiOiIyRUFBQSw4Qjs7QUFFQSxJQUFNQSxXQUFXLFNBQVhBLFFBQVc7QUFDakIsMEVBRGlCLEdBQWpCLEM7Ozs7QUFLZUEsUSIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuXG5jb25zdCBOb3RGb3VuZCA9ICgpID0+XG48ZGl2PlxuICAgIFBBR0UgTk9UIEZPVU5EIC0gNDA0XG48L2Rpdj5cblxuZXhwb3J0IGRlZmF1bHQgTm90Rm91bmQiXX0=


//////////////////
// WEBPACK FOOTER
// ./src/layout/NotFound/index.js
// module id = vtfk
// module chunks = 7